export { EditContactBankAccountModal } from "./edit-contact-bank-account-modal";
